<style>
  .colores {
    position: fixed;
    top: 60%;
    z-index: 1000 !important;
    opacity: .7;
    transition-property: all;
    transition-duration: 1s;
    transition-timing-function: linear;
  }

  .colores div {
    margin: 3px;
  }

  .colores:hover {
    opacity: 1;
  }

  .pe {
    display: none;
    position: fixed;
    width: 200px;
    height: 150px;
    bottom: -50px;
    left: 5px;
    z-index: 10;
  }

  .sh {
    display: block;

  }
</style>
<!-- <div class="colores">
  <a href="https://www.facebook.com/MinPlanificaOficial">
    <div
      style="width:32px;height: 32px;border-radius: 50%;background-color: #FDC716;background-image: url('./assets/facebook.png');">
    </div>
  </a>
  <a href="https://twitter.com/minplanifica">
    <div
      style="width:32px;height: 32px;border-radius: 50%;background-color: #e63f75;background-image: url('./assets/twitter.png');">
    </div>
  </a>
</div> -->

<a href="javascript:;" (click)="popupVisible = true" class="float" style="display: none;">
  <img src="../assets/BOTON_RESULTADOS.jpg">
</a>
<a href="javascript:;" (click)="popupVisible1 = true" class="float1" style="display: none;">
  <img src="../assets/PUMBMH1.jpg">
</a>

<dx-popup class="popup" width="80%" height="auto" [position]="position" [showTitle]="true"
  title="Resultados - Intervenciones Urbanas" [dragEnabled]="true" [closeOnOutsideClick]="true"
  [(visible)]="popupVisible">
  <div *dxTemplate="let data of 'content'">
    <table style="width: 95%">
      <tr style="text-align: center">
        <td><a href="http://www.planificacion.gob.bo/uploads/MUESTRA_COMPLETA_CINE.pdf" target="_blank"><img
              src="http://www.planificacion.gob.bo/uploads/RESULTADOS_CINE.jpg" alt="" height="200" height="134"></a>
        </td>
        <td><a href="http://www.planificacion.gob.bo/uploads/MUESTRA_COMPLETA_CULTURA.pdf" target="_blank"><img
              src="http://www.planificacion.gob.bo/uploads/RESULTADOS_CULTURA.jpg" alt="" height="200" height="134"></a>
        </td>
        <td><a href="http://www.planificacion.gob.bo/uploads/MUESTRA_COMPLETA_INNOVACION.pdf" target="_blank"><img
              src="http://www.planificacion.gob.bo/uploads/RESULTADOS_INNOVACION.jpg" alt="" height="200"
              height="134"></a></td>
      </tr>
    </table>
  </div>
</dx-popup>

<dx-popup class="popup" width="80%" height="auto" [position]="position" [showTitle]="true"
  title="Resultados - Fondo Concursable 2" [dragEnabled]="true" [closeOnOutsideClick]="true"
  [(visible)]="popupVisible1">
  <div *dxTemplate="let data of 'content'">
    <table style="width: 95%">
      <tr style="text-align: center">
        <td><a href="http://www.planificacion.gob.bo/uploads/RESULTADOS_TARIJA.pdf" target="_blank"><img
              src="http://www.planificacion.gob.bo/uploads/TARIJA.jpg" alt="" height="200" height="134"></a>
        </td>
        <td><a href="http://www.planificacion.gob.bo/uploads/RESULTADO_LA_PAZ.pdf" target="_blank"><img
              src="http://www.planificacion.gob.bo/uploads/LA_PAZ.jpg" alt="" height="200" height="134"></a>
        </td>
        <td><a href="http://www.planificacion.gob.bo/uploads/RESULTADO_EL_ALTO.pdf" target="_blank"><img
              src="http://www.planificacion.gob.bo/uploads/EL_ALTO.jpg" alt="" height="200" height="134"></a></td>
        <td><a href="http://www.planificacion.gob.bo/uploads/RESULTADO_VIACHA.pdf" target="_blank"><img
              src="http://www.planificacion.gob.bo/uploads/FONDO_CONCURSABLE_2_MI_BARRIO,_MI_HOGAR_-_VIACHA.jpg" alt=""
              height="200" height="134"></a></td>
        <td><a href="http://www.planificacion.gob.bo/uploads/RESULTADO_ORURO.pdf" target="_blank"><img
              src="http://www.planificacion.gob.bo/uploads/FONDO_CONCURSABLE_2_MI_BARRIO,_MI_HOGAR_-_ORURO.jpg" alt=""
              height="200" height="134"></a></td>
        <td><a href="http://www.planificacion.gob.bo/uploads/RESULTADO_SANTA_CRUZ.pdf" target="_blank"><img
              src="http://www.planificacion.gob.bo/uploads/SANTA_CRUZ1.jpg" alt="" height="200" height="134"></a></td>
      </tr>
      <tr style="text-align: center">
        <td><a href="http://www.planificacion.gob.bo/uploads/RESULTADO_YACUIBA.pdf" target="_blank"><img
              src="http://www.planificacion.gob.bo/uploads/YACUIBA1.jpg" alt="" height="200" height="134"></a>
        </td>
        <td><a href="http://www.planificacion.gob.bo/uploads/RESULTADO_SUCRE.pdf" target="_blank"><img
              src="http://www.planificacion.gob.bo/uploads/SUCRE1.jpg" alt="" height="200" height="134"></a>
        </td>
        <td><a href="http://www.planificacion.gob.bo/uploads/RESULTADO_COCHABAMBA.pdf" target="_blank"><img
              src="http://www.planificacion.gob.bo/uploads/FONDO_CONCURSABLE_2_MI_BARRIO,_MI_HOGAR_-_COCHABAMBA,_QUILLACOLLO,_SACABA1.jpg"
              alt="" height="200" height="134"></a>
        </td>
        <td><a href="http://www.planificacion.gob.bo/uploads/RESULTADO_QUILLACOLLO.pdf" target="_blank"><img
              src="http://www.planificacion.gob.bo/uploads/QUILLACOLLO.jpg" alt="" height="200" height="134"></a>
        </td>
        <td><a href="http://www.planificacion.gob.bo/uploads/RESULTADO_SACABA.pdf" target="_blank"><img
              src="http://www.planificacion.gob.bo/uploads/SACABA.jpg" alt="" height="200" height="134"></a>
        </td>
        <td><a href="http://www.planificacion.gob.bo/uploads/RESULTADO_WARNES.pdf" target="_blank"><img
              src="http://www.planificacion.gob.bo/uploads/WARNES1.jpg" alt="" height="200" height="134"></a>
        </td>
      </tr>
      <tr style="text-align: center">
        <td><a href="http://www.planificacion.gob.bo/uploads/RESULTADO_COBIJA.pdf" target="_blank"><img
              src="http://www.planificacion.gob.bo/uploads/COBIJA.jpg" alt="" height="200" height="134"></a>
        </td>
        <td><a href="http://www.planificacion.gob.bo/uploads/RESULTADO_RIBERALTA.pdf" target="_blank"><img
              src="http://www.planificacion.gob.bo/uploads/RIBERALTA1.jpg" alt="" height="200" height="134"></a>
        </td>
        <td><a href="http://www.planificacion.gob.bo/uploads/RESULTADO_POTOSI1.pdf" target="_blank"><img
              src="http://www.planificacion.gob.bo/uploads/POTOSÍ1.jpg" alt="" height="200" height="134"></a>
        </td>
        <td><a href="http://www.planificacion.gob.bo/uploads/RESULTADO_TRINIDAD.pdf" target="_blank"><img
              src="http://www.planificacion.gob.bo/uploads/TRINIDAD1.jpg" alt="" height="200" height="134"></a>
        </td>
        <td><a href="http://www.planificacion.gob.bo/uploads/RESULTADO_LA_GUARDIA.pdf" target="_blank"><img
              src="http://www.planificacion.gob.bo/uploads/LA_GUARDIA11.jpg" alt="" height="200" height="134"></a>
        </td>
        <td><a href="http://www.planificacion.gob.bo/uploads/RESULTADO_MONTERO.pdf" target="_blank"><img
              src="http://www.planificacion.gob.bo/uploads/MONTERO11.jpg" alt="" height="200" height="134"></a>
        </td>
      </tr>
    </table>
  </div>
</dx-popup>
<!-- header -->
<app-header></app-header>
<!-- header END -->
<!-- Content -->

<router-outlet></router-outlet>
<!-- Content END-->

<!-- Footer -->
<app-footer></app-footer>
<!-- Footer END-->
<!-- scroll top button -->
<div *ngIf="mostrar" style="background-color: red">cargando...</div>


// WEBPACK FOOTER //
// ./src/app/app.component.html